var _path, _path2, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProfile(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.0752 3C6.8752 3 5.0752 4.96 5.0752 7.375C5.0752 9.79 6.8752 11.75 9.0752 11.75C11.2752 11.75 13.0752 9.79 13.0752 7.375C13.0752 4.96 11.2752 3 9.0752 3ZM4.8952 11.75C2.7752 11.8375 1.0752 13.36 1.0752 15.25V17H17.0752V15.25C17.0752 13.36 15.3952 11.8375 13.2552 11.75C12.1752 12.8175 10.6952 13.5 9.0752 13.5C7.4552 13.5 5.9752 12.8175 4.8952 11.75Z",
    fill: "#6A7277"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2138_5099",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 3,
    width: 17,
    height: 14
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.0752 3C6.8752 3 5.0752 4.96 5.0752 7.375C5.0752 9.79 6.8752 11.75 9.0752 11.75C11.2752 11.75 13.0752 9.79 13.0752 7.375C13.0752 4.96 11.2752 3 9.0752 3ZM4.8952 11.75C2.7752 11.8375 1.0752 13.36 1.0752 15.25V17H17.0752V15.25C17.0752 13.36 15.3952 11.8375 13.2552 11.75C12.1752 12.8175 10.6952 13.5 9.0752 13.5C7.4552 13.5 5.9752 12.8175 4.8952 11.75Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2138_5099)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/profile.b8736279affd34054c4695abe03eae63.svg";
export { ForwardRef as ReactComponent };